module.exports = __webpack_public_path__ + "img/20.df6577db.jpg";